export default "__VITE_ASSET__DNacoYxl__"